import {
	Box,
	CircularProgress,
	Divider,
	IconButton,
	SelectChangeEvent,
	Snackbar,
	Typography,
} from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { styled } from 'styled-components';

import { canEditOrder, getBaseRoute, setOrderStatus, truncateField } from '@src/helpers/Helpers';
import { AxiosError, AxiosResponse } from 'axios';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { CustomAlertType } from '@src/pages/Catalogs';

import Papa from 'papaparse';

import { error } from 'console';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { RESTAURANT } from '@src/Constants';
import usePermission from '@src/hooks/usePermission';
import { ALL_PERMISSION_MAP } from '@src/helpers/Permission';
import { Order } from '@src/components/Main/Chat/ChatMessage/ChatMessage';
import CustomTooltip from '@src/components/CustomTootip/CustomTooltip';
import LabeledSelectField, { StatusList } from '@src/components/CustomSelect/LabeledSelectField';
import CustomButton from '@src/components/CustomButton/CustomButton';
import CustomDataGrid2 from '@src/components/CustomDataGrid/CustomDataGrid2';
import {
	AcceptIcon,
	CommentIcon,
	ModalCloseIcon,
	RejectIcon,
	SaveReviewIcon,
} from '@src/components/Icons';
import ProductCard from '@src/pages/Orders/Components/ProductCard';
import PageHeader from '@src/components/PageHeader/PageHeader';
import { OrderView } from '..';
import Loading from '@src/components/Loading/Loading';
import CustomModal from '@src/components/CustomModal';
import ProductApprovalDetails from './ProductApprovalDetails';
import CustomDrawer from '@src/components/CustomDrawer/CustomDrawer';
import ProductQualityCheck from './ProductQualityCheck';
import StyledStatus from './StyledStatus';
import { OrderProduct } from '../acceptDelivery';
import PageHeaderMobile from '@src/components/PageHeader/PageHeaderMobile';
import SlidableDrawer from '@src/components/CustomModal/SlidableDrawer';
import { IsMobileWidth } from '@src/components/MediaQueryUtils';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: auto;
	letter-spacing: 0.28px;
`;

const Status = styled.div<{ id?: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 23px;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 700;
	line-height: 19.1px;
	padding: 2px 6px;
	text-align: center;
	width: auto;
`;

const AmountContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding: 16px;
	p {
		color: var(--default-text-color);
		font-size: 14px;
		font-weight: 700;
		line-height: 18.2px;
		width: 160px;
	}
`;

const CommentContainer = styled.div`
	padding: 16px;
	display: flex;
	gap: 10px;
	color: #333;
	font-size: 14px;
	font-weight: 600;
`;

const StyledText = styled.p`
	color: var(--Gray-g-700, #5c5c5c);
	font-family: 'Nunito Sans';
	font-size: 16px;
	font-weight: 600;
	flex-shrink: 0;
`;

const MobileContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	overflow-y: auto;
	height: auto;
	gap: 10px;
	padding-top: 5px;
	padding-bottom: 5px;
	flex-grow: 1;
	height: calc(90vh - 290px);

	/* Media query for smaller screens */
	/* @media (max-height: 800px) {
		height: calc(100vh - 290px);
		margin-bottom: 70px;
	} */
`;

interface Options {
	id: number;
	name: string;
	color: string;
	background: string;
	statusID: string;
	validationId: number;
}

//For Mobile View
const StyledBottomBtnContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 68px;
	padding: 20px;
	background: var(--chat-header-bg);
	border: 1.5px solid var(--gray-color-light);
	z-index: 100;
	position: fixed;
	bottom: 0;
`;

const StyledTextButton = styled.button`
	color: var(--color-font-grey);
	font-size: 14px;
	font-weight: 600;
	line-height: 18.2px;
	letter-spacing: -0.28px;
	text-decoration-line: underline;
	cursor: pointer;
	background: none;
	border: none;
	padding: 0;
`;

interface ViewOrderProps {
	orderDetails: Order;
	setOrderDetails: (data: Order | null) => void;
	orderInfo: any;
	setOrderInfo: any;
	title: string | undefined;
	alert: CustomAlertType;
	setAlert: (data: CustomAlertType) => void;
	handleClose: any;
	currentUser: any;
	orders?: any;
	setOrders?: any;
	displayCustomError?: any;
	chatTimeStamp?: any;
	setApiCall: (data: boolean) => void;
	view: OrderView;
	setView: (data: OrderView) => void;
	products: OrderProduct[];
	setProducts: (data: OrderProduct[]) => void;
}
const OrderApproval: React.FC<ViewOrderProps> = ({
	title,
	alert,
	setAlert,
	handleClose,
	currentUser,
	orderInfo,
	setOrderInfo,
	orderDetails,
	setOrderDetails,
	orders = [],
	setOrders,
	displayCustomError,
	chatTimeStamp,
	setApiCall,
	view,
	setView,
	products,
	setProducts,
}) => {
	const { apiService }: any = React.useContext(ApplicationContext);
	const { id, waId } = useParams();
	const navigate = useNavigate();
	const isSupplier = currentUser?.type?.toLowerCase() !== RESTAURANT;

	//Permission
	const checkPermission = usePermission();
	const editOrderPermission = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.ORDER?.UPDATE, waId);
	const viewOrderPermission = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.ORDER?.VIEW, waId);
	const viewOrderHistory = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.ORDER?.READ_HISTORY, waId);

	const isMobileWidth = IsMobileWidth();

	const [windowDimensions, setWindowDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});
	const [loading, setLoading] = useState(true);
	const [disable, setDisable] = useState(false);
	const [tabValue, setTabValue] = useState('1');
	const [selectedId, setSelectedId] = useState('');
	const [status, setStatus] = useState<StatusList>([]);
	const [allOptions, setAllOptions] = useState<Options[]>([]);
	const [steps, setSteps] = useState([]);
	const [qualityCheckModal, setQualityCheckModal] = useState(false);
	const [qualityCheckType, setQualityCheckType] = useState<'accept' | 'reject'>('accept');
	const [productDetailsModal, setProductDetailsModal] = useState(false);
	const [productDetails, setProductDetails] = useState<OrderProduct | null>(null);
	const [productCall, setProductCall] = useState(false);
	const [collapse, setCollapse] = useState(false);
	const isDisabledButton = products?.some(
		(product: OrderProduct) => product?.delivery_acc_status?.toLowerCase() === 'pending'
	);

	const OrderDetailsComponent = () => {
		return (
			<>
				<StyledText style={{ padding: '16px' }}>
					"Users can accept the product if satisfied or reject it if dissatisfied. Feel free to
					leave comments and attach images for any defective products."
				</StyledText>
				<div style={{ padding: '0 16px', height: 'calc(100vh - 300px)', width: '100%' }}>
					<CustomDataGrid2
						rows={products}
						columns={columns}
						style={gridStyling}
						onRowsSelectionHandler={onRowsSelectionHandler}
						handleRowClick={handleRowClickListView}
						checkboxSelection={false}
					/>
				</div>
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					{
						<CommentContainer>
							{orderDetails?.comments && <CommentIcon />}
							<p>{orderDetails?.comments}</p>
						</CommentContainer>
					}
					<AmountContainer>
						<p>Total Amount: ₹ {orderDetails?.total}</p>
					</AmountContainer>
				</div>
				{/* {mobileWidth ? (
				<StyledBottomBtnContainer>
					{currentUser?.type?.toLowerCase() === RESTAURANT ? (
						<CustomButton
							title="Export"
							color="primary"
							styles={{
								width: '328px',
								height: '36px',
							}}
							handleClick={exportOrders}
						/>
					) : (
						<CustomButton
							title={
								loading ? (
									<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
								) : (
									'Confirm Order'
								)
							}
							color="primary"
							disabled={disable || orderDetails?.orderStatus?.name !== 'Pending'}
							styles={{
								width: '328px',
								height: '36px',
							}}
							handleClick={changeOrderStatus}
						/>
					)}
				</StyledBottomBtnContainer>
			) : null} */}
			</>
		);
	};

	const updateWindowDimensions = () => {
		setWindowDimensions({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	};

	const mobileWidth = windowDimensions?.width <= 800;
	const getGridWidth = () => {
		if (windowDimensions?.width > 900) {
			return '1074px';
		} else if (windowDimensions?.width > 360) {
			return '90vw';
		} else {
			return '296px';
		}
	};

	const gridStyling = {
		background: 'white',
		color: '#5C5C5C',
		cursor: 'pointer',
		width: getGridWidth(),
		transition: 'height 0.3s ease',
		height: 'calc(100vh - 300px)',
		' .MuiDataGrid-cell': {
			border: 'none',
			outline: 'none !important',
		},
		' .MuiDataGrid-row': {
			borderBottom: '1px solid #F1F1F1',
		},
		' .MuiDataGrid-columnHeader': {
			border: 'none',
			outline: 'none !important',
		},
		'.MuiDataGrid-columnHeaders': {
			overflow: 'visible',
			position: 'relative',
			zIndex: 1,
			background: '#FFECB3 !important',
		},
		'.MuiDataGrid-columnHeaderTitleContainer': {
			overflow: 'visible',
		},
		'.MuiDataGrid-columnHeaderTitle': {
			color: 'black',
			fontWeight: 700,
		},
		'.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
			outline: 'none !important',
			border: 'none !important',
		},
	};

	const detailsArray = [
		{ key: 'Ordered', value: orderDetails?.orderDate },
		{ key: 'Request Delivery', value: orderDetails?.requestedDeliveryDate },
	];

	const handleAccept = (id: string) => {};

	const handleReject = (id: string) => {};

	const statusLabel = (params: any) => {
		const status = params?.row?.delivery_acc_status?.toLowerCase();
		if (['accepted', 'rejected', 'partially_accepted']?.includes(status)) {
			return <StyledStatus status={status} style={{ fontSize: '14px' }} />;
		} else if (status === 'pending' && isSupplier) {
			return <StyledStatus status="pending" style={{ fontSize: '14px' }} />;
		}
		return (
			<div id="btns-container" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
				<IconButton
					id="btn-1"
					onClick={(e) => {
						params?.row?.onClick(e, 'accept');
						setProductDetails(params?.row);
					}}
				>
					<AcceptIcon id="btn-1-svg" />
				</IconButton>
				<IconButton
					id="btn-2"
					onClick={(e) => {
						params?.row?.onClick(e, 'reject');
						setProductDetails(params?.row);
					}}
				>
					<RejectIcon id="btn-2-svg" />
				</IconButton>
			</div>
		);
	};

	const columns = [
		{
			field: 'name',
			headerName: 'Part Name',
			width: 300,
			renderCell: (params: any) => {
				const name = params?.row?.name;
				return (
					<div style={{ display: 'flex', gap: '8px', alignItems: 'center' }} title={name}>
						<img
							src={params?.row?.images?.[0]?.image || params?.row?.image || '/placeholderImage.svg'}
							alt="product-img"
							width="24px"
							height="24px"
						/>
						{params?.row?.name}
					</div>
				);
			},
		},
		{
			field: 'price',
			headerName: 'Unit Price(INR)',
			width: 200,
		},
		{
			field: 'quantity',
			headerName: 'Quantity',
			width: 200,
		},
		{
			field: 'acceptReject',
			headerName: 'Accept / Reject',
			width: 130,
			align: 'center',
			renderCell: (params: any) => {
				return statusLabel(params);
			},
		},
	];
	const onRowsSelectionHandler = () => {};

	const handleRowClickListView = (params: any, event: any) => {
		if (
			!['btn-2', 'btn-1', 'btns-container', 'btn-1-svg', 'btn-2-svg'].includes(event?.target?.id) &&
			!['pending'].includes(params?.row?.delivery_acc_status?.toLowerCase())
		) {
			setProductDetailsModal(true);
			setProductDetails(params?.row);
		}
	};

	const exportToCsv = (tableData: any) => {
		const supplierInfo = {
			'Supplier Name': tableData?.supplier?.name,
		};

		const restaurantInfo = {
			'Dealer Name': tableData?.restaurant?.name,
		};

		const orderData = [
			['Dealer Name', tableData?.restaurant?.name],
			['Supplier Name', tableData?.supplier?.name],
			['Order Date', tableData?.orderDate],
			['Delivery Date', tableData?.deliveryDate],
			['Order Status', tableData?.orderStatus?.name],
			['Total', tableData?.total],
			[], // Add an empty row for separation
		];

		const productData = [
			...tableData?.products?.map((item: any) => ({
				'Product ID': item?.id,
				'Part Name': item?.name,
				Unit: item?.unit,
				Price: item?.price,
				Quantity: item?.quantity,
				Total: item?.total,
			})),
		];

		const csvData = Papa.unparse({
			fields: ['Key', 'Value'],
			data: orderData.concat(Object.entries(supplierInfo), Object.entries(restaurantInfo)),
		});

		const csvData2 = Papa.unparse({
			fields: ['Product ID', 'Part Name', 'Unit', 'Price', 'Quantity', 'Total'],
			data: productData,
		});

		const blob = new Blob([csvData + '\n' + csvData2], { type: 'text/csv' });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'order_items.csv';
		a.click();
		window.URL.revokeObjectURL(url);
	};

	const exportOrders = () => {
		exportToCsv(orderDetails);
	};

	const handleChange = (event: SelectChangeEvent<unknown>) => {
		const selectedValue = event.target.value;
		const selectedOption = allOptions?.find((option) => option?.id === selectedValue);
		if (selectedOption?.name && selectedOption?.id !== orderDetails?.orderStatus?.id) {
			const data = {
				statusId: selectedOption?.statusID,
			};

			setLoading(true);
			setDisable(true);

			apiService.updateOrderStatus(
				data,
				(response: AxiosResponse) => {
					setAlert({
						message: 'Order Status Updated Successfully',
						severity: 'success',
					});
					setSelectedId(selectedValue as string);
					setOrderDetails({
						...orderDetails,
						//@ts-ignore
						orderStatus: {
							color: selectedOption?.color,
							color_bg: selectedOption?.background,
							name: selectedOption?.name,
							id: selectedOption?.id,
							validation_order: selectedOption?.validationId,
						},
					});
					setLoading(false);
					setDisable(false);
					setApiCall(true);
				},
				(error: AxiosError) => {
					displayCustomError(error);
					setLoading(false);
					setDisable(false);
				},
				orderDetails?.cheeniOrderId
			);
		}
	};

	const changeOrderStatus = (data: any) => {};

	const sendToSupplier = () => {
		setView('requestSupplier');
	};

	const handleSaveForReview = () => {
		setAlert({ message: 'Order Products Saved Successfully', severity: 'success' });
		setView('');
		handleClose();
	};

	const filterStatusOptions = (plans: any) => {
		const selectedOptionVaildationOrder = orderDetails?.orderStatus?.validation_order;
		if (
			selectedOptionVaildationOrder &&
			selectedOptionVaildationOrder >= window?.config?.validationOrder
		) {
			const updatedPlans = plans?.map((plan: any) => {
				if (plan?.validationId < selectedOptionVaildationOrder) {
					return { ...plan, disable: true };
				}
				return plan;
			});
			return updatedPlans;
		}
		return plans;
	};

	const transformData = (data: any) => {
		return data.map((group: any) => {
			const plans = group.statuses.map((status: any) => {
				return {
					id: status?.order_status_id,
					name: status.name,
					color: group?.color,
					background: group?.color_bg,
					statusID: status?.order_status_id,
					validationId: group?.validation_order,
				};
			});

			return {
				id: group.group_id,
				name: group.name.toLowerCase(),
				color: group.color,
				colorBg: group.color_bg,
				plans: filterStatusOptions(plans),
			};
		});
	};

	const transformOptions = (data: any) => {
		const plans: Options[] = [];
		data?.forEach((group: any) => {
			group?.statuses?.forEach((status: any) => {
				plans?.push({
					id: status?.order_status_id,
					name: status.name,
					color: group?.color,
					background: group?.color_bg,
					statusID: status?.order_status_id,
					validationId: group?.validation_order,
				});
			});
		});
		return filterStatusOptions(plans);
	};

	const getHistory = () => {
		apiService?.getOrderHistory(
			(response: AxiosResponse) => {
				const history = response?.data?.data?.map((item: any) => {
					return {
						...item,
						number: item?.id,
						title: {
							name: item?.user_name,
							date: moment(item?.created_at).format('DD-MMMM-YYYY'),
							time: moment(item?.created_at).format('hh:mma'),
						},
						changes: item?.logs?.map((item: any) => {
							return item?.log;
						}),
					};
				});
				setSteps(history);
			},
			(error: AxiosError) => {
				displayCustomError(error);
			},
			id,
			orderDetails?.cheeniOrderId
		);
	};

	useEffect(() => {
		apiService?.getProductsByOrderId(
			(response: AxiosResponse) => {
				const data = response?.data?.data;
				const updatedData = data?.map((product: OrderProduct) => {
					return {
						...product,
						id: product?.productId,
						onClick: (e: any, type: 'accept' | 'reject') => {
							setQualityCheckModal(true);
							setQualityCheckType(type);
							setProductDetails(product);
						},
						openProductDetails: (e: any) => {
							if (
								![
									'button-conatiner',
									'button-1',
									'button-2',
									'button-accept',
									'button-reject',
									'btn-2',
									'btn-1',
									'btns-container',
									'btn-1-svg',
									'btn-2-svg',
								].includes(e?.target?.id) &&
								!['pending'].includes(product?.delivery_acc_status?.toLowerCase())
							) {
								setProductDetailsModal(true);
								setProductDetails(product);
							}
						},
					};
				});
				setProducts(updatedData);
				setLoading(false);
				if (productCall) {
					setProductCall(false);
				}
			},
			(error: AxiosError) => {
				displayCustomError(error);
				setLoading(false);
			},
			orderDetails?.orderId
		);
	}, [productCall]);

	//For Mobile Screen
	useEffect(() => {
		window.addEventListener('resize', updateWindowDimensions);

		return () => {
			window.removeEventListener('resize', updateWindowDimensions);
		};
	}, []);

	useEffect(() => {
		updateWindowDimensions();
	}, []);

	useEffect(() => {
		return () => {
			if (isMobileWidth) {
				setOrderDetails(null);
			}
			setView("")
		};
	}, []);

	if (loading) {
		return <Loading />;
	}

	const productListDesktopView = () => {
		return (
			<StyledContainer>
				<Box
					display="flex"
					justifyContent="space-between"
					alignItems="center"
					p={2}
					width="100%"
					height="56px"
				>
					<Box display="flex" alignItems="center" gap="15px">
						<Typography
							variant="body1"
							style={{
								maxWidth: '320px',
								display: 'inline-block',
								overflowWrap: 'break-word',
								wordWrap: 'break-word',
								maxHeight: '50px',
								overflow: 'auto',
							}}
						>
							{isSupplier ? `Order From ${title}` : `Order To ${title}`}
						</Typography>

						<Status
							style={{
								color: orderDetails?.orderStatus?.color,
								background: orderDetails?.orderStatus?.color_bg,
							}}
						>
							{orderDetails?.orderStatus?.name}
						</Status>
					</Box>
					{!isSupplier ? (
						<Box display="flex" alignItems="center" gap="15px">
							{!isSupplier && orderDetails?.sentForReview !== 1 ? (
								<CustomTooltip title="Saved For Review" placement="bottom">
									<IconButton onClick={handleSaveForReview}>
										<SaveReviewIcon />
									</IconButton>
								</CustomTooltip>
							) : null}
							<CustomButton
								title="Send to Supplier"
								color="primary"
								styles={{ height: '36px', width: '157px' }}
								handleClick={() => sendToSupplier()}
								disabled={isDisabledButton || !!orderDetails?.sentForReview}
							/>
							<Box sx={{ cursor: 'pointer' }} onClick={handleClose}>
								<ModalCloseIcon />
							</Box>
						</Box>
					) : (
						<Box sx={{ cursor: 'pointer' }} onClick={handleClose}>
							<ModalCloseIcon />
						</Box>
					)}
				</Box>

				<Divider style={{ width: '100%' }} />
				<OrderDetailsComponent />

				{productDetailsModal ? (
					<CustomModal
						title={productDetails?.name}
						open={productDetailsModal}
						setOpen={setProductDetailsModal}
						style={{
							maxWidth: '444px',
							minWidth: '444px',
							minHeight: 'auto',
							height: 'auto',
						}}
						header
					>
						{productDetails ? (
							<ProductApprovalDetails
								windowDimensions={windowDimensions}
								handleClose={() => setProductDetailsModal(false)}
								setView={setView}
								productDetails={productDetails}
							/>
						) : null}
					</CustomModal>
				) : null}
				{qualityCheckModal ? (
					<CustomModal
						title="Product Quality Check"
						open={qualityCheckModal}
						setOpen={setQualityCheckModal}
						style={{
							maxWidth: '472px',
							minWidth: '472px',
							maxHeight: 'auto',
						}}
						header
					>
						{productDetails ? (
							<ProductQualityCheck
								productDetails={productDetails}
								windowDimensions={windowDimensions}
								handleClose={() => setQualityCheckModal(false)}
								setView={setView}
								setQualityCheckModal={setQualityCheckModal}
								type={qualityCheckType}
								setApiCall={setProductCall}
								setAlert={setAlert}
								displayCustomError={displayCustomError}
							/>
						) : null}
					</CustomModal>
				) : null}
			</StyledContainer>
		);
	};

	const productListMobileView = () => {
		const handleArrowBack = () => {
			if (view === 'orderDetails') {
				setView('');
				handleClose();
				return;
			} else if (view === 'qualityCheck') {
			} else if (view === 'requestSupplier') {
			}
			navigate(-1);
		};
		return (
			<div style={{ height: '90vh', overflow: 'hidden' }}>
				{isMobileWidth ? (
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-start',
							alignItems: 'flex-start',
							padding: '20px 10px 10px 10px',
							flexShrink: 0,
							width: '100%',
						}}
					>
						<p
							style={{
								color: '#5C5C5C',
								fontFamily: 'Poppins',
								fontSize: '16px',
								fontWeight: 400,
							}}
						>
							{isSupplier ? `Order From ${title}` : `Order To ${title}`}
						</p>
					</Box>
				) : (
					<PageHeader
						title={isSupplier ? `Order From ${title}` : `Order To ${title}`}
						handleArrowBack={handleArrowBack}
						activeIcon={true}
						activeHamburgerIcon={false}
					/>
				)}
				<div
					style={{
						margin: '12px',
						display: 'flex',
						justifyContent: 'flex-start',
						flexDirection: 'column',
						gap: '12px',
						flexShrink: 0,
					}}
				>
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<Status
							style={{
								color: orderDetails?.orderStatus?.color,
								background: orderDetails?.orderStatus?.color_bg,
								display: 'flex',
								width: '100%',
								height: '30px',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
								maxWidth: '260px',
							}}
						>
							{orderDetails?.orderStatus?.name}
						</Status>
						{!isSupplier && orderDetails?.sentForReview !== 1 ? (
							<CustomTooltip title="Saved For Review" placement="bottom">
								<IconButton onClick={handleSaveForReview}>
									<SaveReviewIcon />
								</IconButton>
							</CustomTooltip>
						) : null}
					</div>
					<StyledText>
						"Users can accept the product if satisfied or reject it if dissatisfied. Feel free to
						leave comments and attach images for any defective products."
					</StyledText>
				</div>
				<MobileContainer>
					{products?.map((product) => {
						return <ProductCard product={product} />;
					})}
				</MobileContainer>
				{!isSupplier ? (
					<StyledBottomBtnContainer>
						<CustomButton
							type="submit"
							title="Send to Supplier"
							handleClick={() => sendToSupplier()}
							styles={{
								width: '328px',
								height: '36px',
							}}
							disabled={isDisabledButton || !!orderDetails?.sentForReview}
						/>
					</StyledBottomBtnContainer>
				) : null}
				{productDetailsModal ? (
					<CustomDrawer
						title={productDetails?.name}
						open={productDetailsModal}
						setOpen={setProductDetailsModal}
						style={{
							maxWidth: '100%',
							minWidth: '100%',
							maxHeight: '100%',
						}}
						header
					>
						{productDetails ? (
							<ProductApprovalDetails
								windowDimensions={windowDimensions}
								handleClose={() => setProductDetailsModal(false)}
								setView={setView}
								productDetails={productDetails}
							/>
						) : null}
					</CustomDrawer>
				) : null}
				{qualityCheckModal ? (
					<SlidableDrawer
						isOpen={qualityCheckModal}
						setIsOpen={setQualityCheckModal}
						onClose={() => {
							setQualityCheckModal(false);
						}}
					>
						{productDetails ? (
							<ProductQualityCheck
								productDetails={productDetails}
								windowDimensions={windowDimensions}
								handleClose={() => setQualityCheckModal(false)}
								setView={setView}
								setQualityCheckModal={setQualityCheckModal}
								type={qualityCheckType}
								setApiCall={setProductCall}
								setAlert={setAlert}
								displayCustomError={displayCustomError}
							/>
						) : null}
					</SlidableDrawer>
				) : null}
			</div>
		);
	};

	return <>{windowDimensions?.width > 768 ? productListDesktopView() : productListMobileView()}</>;
};

export default OrderApproval;
